// hooks/useDemoTour.js
import { useCallback, useMemo, useState } from "react";

export const PRODUCT_TOUR_STORAGE_KEY = "hasCompletedProductTour";

export function hasCompletedProductTour() {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(PRODUCT_TOUR_STORAGE_KEY) === "true";
}

export function markProductTourCompleted() {
  if (typeof window === "undefined") return;
  localStorage.setItem(PRODUCT_TOUR_STORAGE_KEY, "true");
}

/** Wait until a tour target is in the DOM and has a non-zero size. */
export function waitForTourTarget(selector, timeoutMs = 2500) {
  return new Promise((resolve) => {
    if (typeof document === "undefined") {
      resolve(false);
      return;
    }
    const started = Date.now();
    const tick = () => {
      const el = document.querySelector(selector);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          resolve(true);
          return;
        }
      }
      if (Date.now() - started >= timeoutMs) {
        resolve(false);
        return;
      }
      requestAnimationFrame(tick);
    };
    tick();
  });
}

export function useDemoTour() {
  const [runTour, setRunTour] = useState(false);
  const [tourFinished, setTourFinished] = useState(false);

  const startTour = useCallback(() => setRunTour(true), []);

  const resetTour = useCallback(() => {
    setRunTour(false);
    setTourFinished(false);
  }, []);

  return useMemo(
    () => ({
      runTour,
      setRunTour,
      tourFinished,
      setTourFinished,
      startTour,
      resetTour,
    }),
    [runTour, tourFinished, startTour, resetTour]
  );
}
